module.exports = __webpack_public_path__ + "img/19.389941a5.jpg";